import { ContentWithEyeColumn } from 'components/TableColumn/ContentWithEyeColumn';
import { NameWithIdColumn } from 'components/TableColumn/NameWithIdColumn';
import { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './siteAnnouncementNameIdWithDetailColumn.module.scss';
import i18n from 'i18n';
import { SiteAnnouncement } from 'core/siteAnnouncement/SiteAnnouncement';
import { SiteAnnouncementDetailModal } from './SiteAnnouncementDetailModal';
import { useCoreContext } from 'contexts/coreContext';

export const SiteAnnouncementNameIdWithDetailColumn: React.FC<{
  announcement: SiteAnnouncement;
  defaultShowDetail?: boolean;
}> = ({
  announcement,
  defaultShowDetail = false
}) => {

  const [showDetail, setShowDetail] = useState<boolean>(defaultShowDetail);

  const core = useCoreContext();
  const authenticationManager = core?.authenticationManager;

  useEffect(() => {
    if (showDetail) {
      authenticationManager?.markAnnouncementAsRead(announcement);
      window.dispatchEvent(new CustomEvent('announcements-read', {
        detail: { announcementIdList: [announcement.id] }
      }));
    }
  }, [showDetail, authenticationManager, announcement]);

  const showDetailModal = useCallback(() => {
    setShowDetail(true);
  }, []);

  const hideDetailModal = useCallback(() => {
    setShowDetail(false);
  }, []);

  const tooltipProps = useMemo(() => ({
    id: `faEye-tooltip-${announcement.id}`,
    tooltip: i18n.t<string>('siteAnnouncementList.buttons.showDetail')
  }), [announcement]);

  return (
    <div className={styles.siteAnnouncementNameIdWithDetailColumn}>
      <ContentWithEyeColumn
        value={announcement.id}
        className={styles.eyeColumnContainer}
        iconClassName={styles.eyeClassName}
        onClickBtn={showDetailModal}
        tooltipProps={tooltipProps}
        contentData={{
          component: NameWithIdColumn,
          props: {
            id: announcement.id,
            name: announcement.name,
            className: styles.nameWithIdColumn,
            showId: true
          }
        }}
      />
      {showDetail && (
        <SiteAnnouncementDetailModal
          announcement={announcement}
          onClose={hideDetailModal}
        />
      )}
    </div>
  );
};

export const renderSiteAnnouncementNameIdWithDetailColumn = (
  autoOpenAnnouncementId?: number
) => (announcement: SiteAnnouncement) => {
  return (
    <SiteAnnouncementNameIdWithDetailColumn
      announcement={announcement}
      defaultShowDetail={autoOpenAnnouncementId === announcement.id}
    />
  );
};
